import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
//import { toast } from "react-toastify";


const initialState ={
    stisLoading : false,
    tourType: [],
    totalTourType: 0,
    numOfPages: 1,
    page: 1,
    stats: {},
    monthlyApplications: [],
    stiscLoading:false,
    stcstatus:"",
    stcMessage:"",
    stdetails:{},
    stismloading:false,
    stmstatus:"",
    stmmessage:"",
    stSDetails: {},
    stdstatus:"",
    stdmessage:"",
    error:"",
    
};


const tourTypeSlice = createSlice({
    name: "tourTypesList",
    initialState,
    reducers:{
        getTourTypePending: (state) => {
            state.stisLoading = true;
        },
        getTourTypeSuccess: (state, { payload }) => {
            state.stisLoading = false;
            state.tourType = payload;
            state.stdetails = payload;
        
            state.error = '';
        },
        getTourTypeFail: (state, { payload }) => {
            state.stisLoading = false;
            state.error = payload;
        },
        createTourTypePending:(state,action) => {
            state.stiscloading=true;
        },
        createTourTypeSuccess:(state,{payload}) => {
            state.stiscloading=false;
            state.stcstatus="success";
            state.stcMessage=payload;
        },
        createTourTypeFail:(state,{payload}) => {
            state.stiscloading=false;
            state.stcstatus="fail";
            //console.log('slice '+payload);
            state.stcmessage=payload;
        },
        getSTourTypePending: (state) => {
            state.stisLoading = true;
        },
        getSTourTypeSuccess: (state, { payload }) => {
            state.stisLoading = false;
            state.stSDetails=payload;
            state.error = '';
        },
        getSTourTypeFail: (state, { payload }) => {
            state.stisLoading = false;
            state.error = payload;
        },
        modifyTourTypePending:(state,action) => {
            state.stismloading=true;
            state.stmstatus="";
        },
        modifyTourTypeSuccess:(state,{payload}) => {
            state.stismloading=false;
            state.stmstatus="success";
           
            state.stmmessage="Tour Type Successfully Updated";
        },
        modifyTourTypeail:(state,{payload}) => {
            state.stismloading=false;
            state.stmstatus="fail";
           // console.log('slice '+payload);
            state.stmmessage=payload;
        },
        deleteTourTypePending:(state,action) => {
            state.stisloading=true;
            state.stdstatus="";
        },
        deleteTourTypeSuccess:(state,{payload}) => {
            state.stisLoading=false;
            state.stdstatus="success";
            state.stdmessage="Tour Type Successfully Deleted";
        },
        deleteTourTypeFail:(state,{payload}) => {
            state.stisLoading=false;
            state.stdstatus="fail";
           // console.log('slice '+payload);
            state.stdmessage=payload;
        },
        reset: () => initialState
    },
});

const { reducer, actions } = tourTypeSlice;

export const { getTourTypePending, getTourTypeSuccess, getTourTypeFail,getSTourTypePending, getSTourTypeSuccess, getSTourTypeFail, 
    createTourTypePending, createTourTypeSuccess, createTourTypeFail,
    modifyTourTypePending,modifyTourTypeSuccess,modifyTourTypeFail,
    deleteTourTypePending,deleteTourTypeSuccess,deleteTourTypeFail  } = actions;

export default reducer;
